<template>
    <v-container>
      <template v-if="maintain">
        <div class="d-flex justify-center align-center">
          <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
        </div>
      </template>
      <template v-else>
        <template v-if="CheckAdmin">
            <v-card>
                <v-card-title style="background-color: #364eff;color: white">
                    จัดการข้อมูลตำแหน่งบริหาร/หัวหน้าหน่วยงาน
                </v-card-title>
                <v-container>
                    <v-card>
                        <v-row
                                class="md12 d-flex justify-center"
                        >
                            <v-col
                                    cols="12"
                                    md="5">
                                <v-list-item>
                                    <h3 style="font-weight: bold;">
                                        จัดการข้อมูลตำแหน่ง
                                    </h3>
                                </v-list-item>
                                <v-list-item class="d-flex justify-center">
                                    <v-radio-group v-model="row" row>
                                        <v-radio class="font-weight-bold" label="เพิ่มข้อมูล" value="1"></v-radio>
                                        <v-radio class="font-weight-bold" label="แก้ไขข้อมูล" value="2"></v-radio>
                                    </v-radio-group>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-row class="d-flex justify-center">
                                        <v-col cols="12" md="6">
                                            <v-autocomplete v-if="row == '2'" v-model="type_id" label="ชื่อตำแหน่ง"
                                                            :items="ManagerialData" item-text="supervisor_type_name"
                                                            item-value="supervisor_type_id"
                                                            @change="ChooseTypeSupervisor"></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-list-item>
                                <v-list-item>
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field label="ชื่อตำแหน่ง" v-model="name"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field label="ระดับ" v-model="level" type="number"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-list-item>
                                <v-list-item class="d-flex justify-center">
                                    <v-btn color="primary" outlined v-if="row == '1'"
                                           @click="insertDataManagerialPosition">
                                        เพิ่มข้อมูล
                                    </v-btn>
                                    <v-btn color="#FF9800" outlined v-else @click="editDataManagerialPosition">
                                        แก้ไขเพิ่มข้อมูล
                                    </v-btn>
                                </v-list-item>
                            </v-col>
                            <v-divider vertical>
                            </v-divider>
                            <v-col
                                    cols="12"
                                    md="5">
                                <v-list-item>
                                    <h3 style="font-weight: bold;">
                                        ตำแหน่ง
                                    </h3>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item v-for="(managerial_i, idx) in managerialData" v-bind:key="idx">
                                    <span style="font-weight: bold;color: darkslategrey;" v-if="managerial_i.active == '1'">
                                        {{idx + 1}}) {{managerial_i.supervisor_type_name}}
                                    </span>
                                    <span style="font-weight: bold;color: red;" v-else>
                                        {{idx + 1}}) {{managerial_i.supervisor_type_name}}
                                    </span>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue" text>
                                        <span style="font-weight: bold" @click="ChangeDataManagerialConfirm(managerial_i, true)">
                                            ใช้งาน
                                        </span>
                                    </v-btn>
                                    <v-btn color="red" text>
                                        <span style="font-weight: bold" @click="ChangeDataManagerialConfirm(managerial_i, false)">
                                            ยกเลิก
                                        </span>
                                    </v-btn>
                                </v-list-item>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-container>
            </v-card>
            <template>
                <v-dialog
                        v-model="dialogDelete"
                        max-width="290"
                >
                    <v-card>
                        <v-card-title class="headline">ยืนยันการทำรายการ</v-card-title>

                        <v-card-text v-if="managerialDelete != null">
                            คุณต้องการลบข้อมูล ตำแหน่งทางการบริหาร : {{managerialDelete.supervisor_type_name}}
                            ใช่หรือไม่
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    color="green darken-1"
                                    text
                                    @click="deleteDataManagerialPosition"
                            >
                                ตกลง
                            </v-btn>
                            <v-btn
                                    color="red"
                                    text
                                    @click="dialogDelete = false"
                            >
                                ยกเลิก
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
        </template>
        <template v-else></template>
      </template>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import axios from "axios";
    import ConstData from "@/const/Const";

    export default {
        name: "SettingManagerial",
        data() {
            return {
              pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
              maintain: false,
                CheckAdmin: false,
                dialogDelete: false,
                type_id: '',
                isMobile: false,
                managerialData: [],
                managerialDelete: null,
                row: '1',
                name: '',
                level: ''
            }
        },
        computed: {
            ...mapGetters({
                MeData: 'Staff/getMeData',
                levelData: 'Level/getLevel',
                DepartData: 'Depart/getDepart',
                PositionsData: 'Positions/getPosition',
                ManagerialData: 'Positions/getPositionManagerial',
                Course: 'Course/getCourse',
                Competency: 'Competency/getConpetency',
              AllDepPermission: 'Permission/getAllDepUserPermission',
              DepPermission: 'Permission/getDepUserPermission',
              PermissionAdmin: 'Permission/getPermission',
              Permission: 'Permission/getPermissionUser',
              Permission_Ms: 'Permission/getPermissionMs',
              Permission_Dep_User: 'Permission/getPermissionDepUser',
              Permission_Dep: 'Permission/getPermissionDep',
              Approve_Ms: 'Permission/getApproveMs',
              Approve: 'Permission/getApprove',
              MenuPermiss: 'Permission/getMenuPermiss',
              IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
              appColor: 'Page/getColor',
              appHeaderName: 'Page/getHeaderName',
            }),
        },
        methods: {
            ...mapActions({
                initMeData: 'Staff/initMeData',
                initlevelData: 'Level/initLevelData',
                initDepartData: 'Depart/initDepartData',
                initPositionData: 'Positions/initPositionData',
                initPosi_ManagerialData: 'Positions/initPosi_ManagerialData',
                initCourseData: 'Course/initCourseData',
                initCompetencyData: 'Competency/initCompetencyData',
              initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
              initPermissionDepUserData: 'Permission/initPermissionDepUserData',
              initPermissionUserData: 'Permission/initPermissionUserData',
              initPermissionMsData: 'Permission/initPermissionMsData',
              getPermissionUserData: 'Permission/getPermissionUserData',
              getPermissionDep: 'Permission/getPermissionDepData',
              initPermissionDepData: 'Permission/initPermissionDepData',
              getPermissionDepUserData: 'Permission/getPermissionDepUserData',
              initApproveMsData: 'Permission/initApproveMsData',
              initApproveData: 'Permission/initApproveData',
              getPermissionData: 'Permission/getPermissionData',
              initPermissionData: 'Permission/initPermissionData',
              getMenuPermissData: 'Permission/getMenuPermissData',
              getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
              changeColor: 'Page/changeColor',
              changeHeaderName: 'Page/changeHeaderName',
              changeTypeProject: 'Project/changeTypeProject',
            }),
            onResize() {
                this.isMobile = window.innerWidth < 600
            },
            init() {
                this.managerialData = []
                this.initPosi_ManagerialData().then(res => {
                    if (res) {
                        this.ManagerialData.map(Managerial_i => {
                            this.managerialData.push(
                                {
                                    ...Managerial_i,
                                    Choose: false,
                                }
                            )
                        })
                    }
                })
            },
            insertDataManagerialPosition() {
              var CheckInsert = false
              if (this.PermissionAdmin.length > 0) {
                this.PermissionAdmin.map((Per_i, idx) => {
                  if(Per_i.permission_id == '5001') {
                    CheckInsert = true

                    const headerAxios = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'PUT'
                      }
                    }
                    const params = {
                      supervisor_type_id: parseInt(this.managerialData[this.managerialData.length - 1].supervisor_type_id) + 1,
                      supervisor_type_name: this.name,
                      supervisor_type_level: this.level,
                      active: '1'
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/supervisor_type_ms/', params, headerAxios).then(res => {
                      if (res.data.status) {
                        this.$swal.fire({
                          icon: 'success',
                          title: 'บันทึกข้อมูลสำเร็จ'
                        })
                        this.name = ''
                        this.level = ''
                        this.init()
                      }
                    })
                  } else {
                    if(!CheckInsert && idx == this.PermissionAdmin.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              } else {
                this.Permission.map((Per_i, idx) => {
                  if(Per_i.permission_id == '5001') {
                    CheckInsert = true

                    const headerAxios = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'PUT'
                      }
                    }
                    const params = {
                      supervisor_type_id: parseInt(this.managerialData[this.managerialData.length - 1].supervisor_type_id) + 1,
                      supervisor_type_name: this.name,
                      supervisor_type_level: this.level,
                      active: '1'
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/supervisor_type_ms/', params, headerAxios).then(res => {
                      if (res.data.status) {
                        this.$swal.fire({
                          icon: 'success',
                          title: 'บันทึกข้อมูลสำเร็จ'
                        })
                        this.name = ''
                        this.level = ''
                        this.init()
                      }
                    })
                  } else {
                    if(!CheckInsert && idx == this.Permission.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              }

            },
            editDataManagerialPosition() {

              var CheckEdit = false
              if (this.PermissionAdmin.length > 0) {
                this.PermissionAdmin.map((Per_i, idx) => {
                  if(Per_i.permission_id == '5001') {
                    CheckEdit = true

                    var ManagerialData = this.managerialData.filter(managerial_i => managerial_i.supervisor_type_id == this.type_id)

                    if (ManagerialData.length > 0) {
                      const headerAxios = {
                        headers: {
                          'Content-Type': 'application/json',
                          'X-REST-METHOD': 'POST'
                        }
                      }
                      const params = {
                        supervisor_type_id: parseInt(this.managerialData[this.managerialData.length - 1].supervisor_type_id) + 1,
                        supervisor_type_name: this.name,
                        supervisor_type_level: this.level,
                        active: '1'
                      }
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/supervisor_type_ms/supervisor_type_id/' + ManagerialData[0].supervisor_type_id, params, headerAxios).then(res => {
                        if (res.data.status) {
                          this.$swal.fire({
                            icon: 'success',
                            title: 'แก้ไขข้อมูลสำเร็จ'
                          })
                          this.name = ''
                          this.level = ''
                          this.type_id = ''
                          this.init()
                        }
                      })
                    } else {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'โปรดเลือกตำแหน่ง'
                      })
                    }
                  } else {
                    if(!CheckEdit && idx == this.PermissionAdmin.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              } else {
                this.Permission.map((Per_i, idx) => {
                  if(Per_i.permission_id == '5001') {
                    CheckEdit = true

                    var ManagerialData = this.managerialData.filter(managerial_i => managerial_i.supervisor_type_id == this.type_id)

                    if (ManagerialData.length > 0) {
                      const headerAxios = {
                        headers: {
                          'Content-Type': 'application/json',
                          'X-REST-METHOD': 'POST'
                        }
                      }
                      const params = {
                        supervisor_type_id: parseInt(this.managerialData[this.managerialData.length - 1].supervisor_type_id) + 1,
                        supervisor_type_name: this.name,
                        supervisor_type_level: this.level,
                        active: '1'
                      }
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/supervisor_type_ms/supervisor_type_id/' + ManagerialData[0].supervisor_type_id, params, headerAxios).then(res => {
                        if (res.data.status) {
                          this.$swal.fire({
                            icon: 'success',
                            title: 'แก้ไขข้อมูลสำเร็จ'
                          })
                          this.name = ''
                          this.level = ''
                          this.type_id = ''
                          this.init()
                        }
                      })
                    } else {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'โปรดเลือกตำแหน่ง'
                      })
                    }
                  } else {
                    if(!CheckEdit && idx == this.Permission.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              }

            },
            deleteDataManagerialConfirm(item) {
              this.CheckAdmin = false
              this.Permission.map((Per_i, idx) => {
                if(Per_i.permission_id == '5001') {
                  this.CheckAdmin = true

                  this.managerialDelete = null
                  this.dialogDelete = true
                  this.managerialDelete = item
                } else {
                  if(!this.CheckAdmin && idx == this.Permission.length - 1) {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                    })
                  }
                }
              })
            },
            ChangeDataManagerialConfirm(item, active) {
                const headerAxios = {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
                var cordi = false
              var CheckChange = false
              if (this.PermissionAdmin.length > 0) {
                this.PermissionAdmin.map((Per_i, idx) => {
                  if (Per_i.permission_id == '5001') {
                    CheckChange = true
                    if (active) {
                      cordi = true
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/supervisor_type_ms/supervisor_type_id/' + item.supervisor_type_id, {
                      active: cordi
                    }, headerAxios).then(res => {
                      if (res.data.status) {
                        if(active) {
                          this.$swal.fire({
                            icon: 'success',
                            title: item.supervisor_type_name + ' เปิดใช้งาน!!'
                          })
                        } else {
                          this.$swal.fire({
                            icon: 'success',
                            title: item.supervisor_type_name + ' ยกเลิกใช้งาน!!'
                          })
                        }

                        this.init()
                        this.dialogDelete = false
                      } else {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้สำเร็จ'
                        })
                      }
                    })
                  } else {
                    if (!CheckChange && idx == this.PermissionAdmin.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              } else {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '5001') {
                    CheckChange = true
                    if (active) {
                      cordi = true
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/supervisor_type_ms/supervisor_type_id/' + item.supervisor_type_id, {
                      active: cordi
                    }, headerAxios).then(res => {
                      if (res.data.status) {
                        if(active) {
                          this.$swal.fire({
                            icon: 'success',
                            title: item.supervisor_type_name + ' เปิดใช้งาน!!'
                          })
                        } else {
                          this.$swal.fire({
                            icon: 'success',
                            title: item.supervisor_type_name + ' ยกเลิกใช้งาน!!'
                          })
                        }

                        this.init()
                        this.dialogDelete = false
                      } else {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้สำเร็จ'
                        })
                      }
                    })
                  } else {
                    if (!CheckChange && idx == this.Permission.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              }
            },
            deleteDataManagerialPosition() {
                const headerAxios = {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'DELETE'
                    }
                }
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/supervisor_type_ms/supervisor_type_id/' + this.managerialDelete.supervisor_type_id, '', headerAxios).then(res => {
                    if (res.data.status) {
                        this.$swal.fire({
                            icon: 'success',
                            title: 'ลบข้อมูลสำเร็จ'
                        })
                        this.init()
                        this.dialogDelete = false
                    }
                })
            },
            ChooseTypeSupervisor() {
                this.name = ''
                this.level = ''

                var ManagerialData = this.managerialData.filter(managerial_i => managerial_i.supervisor_type_id == this.type_id)

                if (ManagerialData.length > 0) {
                    this.name = ManagerialData[0].supervisor_type_name
                    this.level = ManagerialData[0].supervisor_type_level
                }

            }
        },
        mounted() {
          this.changeColor({
            color: ConstData.defaultColorApp
          })
          this.changeHeaderName({
            headerName: ConstData.defaultHeaderApp
          })
          this.changeTypeProject({
            type: null
          })
            this.onResize()
            window.addEventListener('resize', this.onResize, {passive: true})
            this.initMeData().then(async res => {
              if (res) {
                await this.getIgnoreMenuPermissData({
                  perid: this.MeData[0].perid,
                  page_id: '16'
                })
                this.getMenuPermissData().then(res => {
                  if (res) {
                    if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '16' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                      this.maintain = false
                      this.getPermissionData({
                        perid: this.MeData[0].perid
                      }).then(res => {
                        if (res) {
                          this.PermissionAdmin.map((Per_i, idx) => {
                            if (Per_i.permission_id == '5000') {
                              this.CheckAdmin = true

                              this.init()
                            } else {
                              if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                                this.$router.push('/')
                              }
                            }
                          })
                        } else {
                          // this.$router.push('/')
                          this.getPermissionUserData({
                            perid: this.MeData[0].perid
                          }).then(res => {
                            if (res) {
                              this.Permission.map((Per_i, idx) => {
                                if (Per_i.permission_id == '5000') {
                                  this.CheckAdmin = true

                                  this.init()
                                } else {
                                  if (!this.CheckAdmin && idx == this.Permission.length - 1) {
                                    this.$router.push('/')
                                  }
                                }
                              })
                            } else {
                              this.$router.push('/')
                            }
                          })
                        }
                      })
                    } else {
                      this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '16' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '16')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                      this.maintain = true
                    }
                  }
                }).then(err => {
                  if (err) {
                    this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '16' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '16')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                    this.maintain = true
                  }
                })
              }
            }).catch(reason => {
                console.log('Reject = ' + reason)
            })
        }
    }
</script>

<style scoped>
    .v-label {
        color: black;
    }

    .v-card {
        border: 1px solid;
    }

    .v-text-field >>> input {
        color: black;
    }

    .v-text-field >>> label {
        color: black;
        font-weight: bold;
    }

    .v-text-field >>> button {
        font-size: 0.1em;
    }
</style>
